/**
 * The screens. Each answers one question YNAB does not.
 *
 * `path` is the URL segment. Keeping it beside the id and the label means a screen
 * is one entry in one list rather than three lists that can disagree — see
 * `lib/router.ts`, which derives both directions of the mapping from here.
 */
export const SCREENS = [
  { id: 'ahead', label: 'Ahead', path: '/' },
  { id: 'fill', label: 'Fill', path: '/fill' },
  { id: 'ask', label: 'Ask', path: '/ask' },
  { id: 'loans', label: 'Loans', path: '/loans' },
  { id: 'cushion', label: 'Cushion', path: '/cushion' },
  { id: 'back', label: 'Looking back', path: '/looking-back' },
  { id: 'loose', label: 'Loose ends', path: '/loose-ends' },
] as const

export type Screen = (typeof SCREENS)[number]['id']
